<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>待开单商家列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    filterable="filterable"
                    multiple
                    placeholder="代采组"
                  >
                    <el-option
                      v-for="item in filter.optionPg"
                      :key="item.pgid"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.supply"
                    filterable="filterable"
                    placeholder="选择商家"
                  >
                    <el-option key="0" label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in option.supply_list"
                      :key="item.supply_id"
                      :label="item.supply_name"
                      :value="item.supply_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    filterable="filterable"
                    placeholder="开单状态"
                  >
                    <el-option
                      v-for="item in status_list"
                      :key="item.status_id"
                      :label="item.status_name"
                      :value="item.status_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.package_status"
                    filterable="filterable"
                    placeholder="是否已收包"
                  >
                    <el-option
                      v-for="item in package_status"
                      :key="item.status_id"
                      :label="item.status_name"
                      :value="item.status_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_order_ability"
                    placeholder="爆版自主开单"
                  >
                    <el-option
                      v-for="item in is_order_ability"
                      :key="item.status_id"
                      :label="item.status_name"
                      :value="item.status_id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    filterable
                    multiple
                    placeholder="代采员"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in filter.optionPgMember"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.city"
                    placeholder="请选择商家城市"
                    multiple
                  >
                    <el-option
                      v-for="item in supply_city_attr"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="计划来源: ">
                  <el-select v-model="plan_source">
                    <el-option value="1" label="代采计划"></el-option>
                    <el-option value="199" label="小店分发"></el-option>
                    <el-option value="10" label="买版计划"></el-option>
                    <el-option value="9" label="爆款备货计划"></el-option>
                    <el-option value="11" label="提前代采"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.is_reach" placeholder="是否已触达">
                    <el-option label="全部" value=""> </el-option>
                    <el-option label="是" value="2"> </el-option>
                    <el-option label="否" value="1"> </el-option>
                  </el-select>
                </el-form-item>
                <br />
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>核单列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.supply_list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="supply_name" label="商家" align="center">
            </el-table-column>
            <el-table-column
              prop="order_ability_status"
              label="爆版自主开单"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="plan_source"
              label="计划来源"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_nikename"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_floor"
              label="楼层"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_purchase_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_cg_num"
              sortable
              label="待开单数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wait_cg_total"
              sortable
              label="待开单金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wpc_num"
              sortable
              label="急救箱"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cg_num"
              sortable
              label="已开单数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="package_num"
              sortable
              label="收包数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              sortable
              label="生成时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="reach_time"
              sortable
              label="触达时间"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看详情</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  style="margin-left: 8px"
                  @click="copy(scope.row)"
                  >H5链接</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  data() {
    return {
      filter: {
        optionPg: [],
        optionOrigin: [],
        optionHandleState: [],
        optionBlpType: [],
      },
      resData: {
        pg_list: [],
      },
      searchOptions: {
        pg_list: [],
      },
      form: {
        status: "",
        purchase_name: "",
        city: [],
        is_reach: "",
        pgid: [],
        pg_member_id: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WcgPlan/waitConfirmSupplyList",
      curPage: 1,
      filterFold: false,
      status_list: [
        { status_id: 0, status_name: "全部" },
        { status_id: 1, status_name: "未代采" },
        { status_id: 2, status_name: "已上传" },
        { status_id: 3, status_name: "部分完成" },
        { status_id: 4, status_name: "已完成" },
      ],
      package_status: [
        { status_id: 0, status_name: "全部" },
        { status_id: 1, status_name: "是" },
        { status_id: 2, status_name: "否" },
      ],
      is_order_ability: [
        { status_id: 0, status_name: "全部" },
        { status_id: 1, status_name: "是" },
        { status_id: 2, status_name: "否" },
      ],
      supply_city_attr: CITY,
      option: { supply_list: [] },
      plan_source: "1", // 计划来源
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  created() {
    console.log(
      "🚀 ~ file: WaitingPurchase.vue ~ line 397 ~ created ~ created"
    );
    this.form.pgid =
      this.$route.query.pg_group_id &&
      this.$route.query.pg_group_id.split(",").filter((item) => item);
    this.form.city =
      this.$route.query.city &&
      this.$route.query.city.split(",").filter((item) => item);
    this.form.pg_member_id =
      this.$route.query.pg_member_id &&
      this.$route.query.pg_member_id.split(",").filter((item) => item);
    // this.fetchData();
    this.getFilter();
  },
  activated() {
    console.log(
      "🚀 ~ file: WaitingPurchase.vue ~ line 408 ~ activated ~ activated"
    );
  },
  methods: {
    getFilter() {
      this.$http
        .post("/erp/NoDataGoods/getNoDataGoodsListFilter", {})
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error("数据加载失败,请刷新页面");
          } else {
            this.filter = res.data.data;
          }
        });
    },
    copy(row) {
      this.$http
        .post("/buyer/Purchase/h5ConfirmWaitingPurchase", {
          supply_id: row.supply_id,
          plan_id: row.planid,
          is_dispense: row.is_dispense,
        })
        .then((res) => {
          // this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            const url = `${res.data.data.url}\n${row.supply_name}\n${res.data.data.time}`;
            const oInput = document.createElement("textarea");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$message({
              message: "复制成功",
              type: "success",
            });
            oInput.remove();
          }
        });
    },
    output() {
      this.form.is_excel = 1;
      const url = this.getUrl();
      this.$http.post(url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.filteredForm.get_search_options = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.searchOptions = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      const supply_name = row.supply_name.replaceAll("/", "$s");
      const pgname = row.pgname.replaceAll("/", "$s");
      this.$router.push(
        `/home/purchaseverify/waitingpurchasedetail/${row.pgid}/${
          row.supply_id
        }/${pgname}/${supply_name}/${row.settle_type}/${row.planid || 0}/${
          row.is_dispense_bool
        }/${this.form.ptype}`
      );
    },
    search() {
      this.filteredForm.get_search_options = 0;
      const url = this.getUrl();
      this.$http.post(url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          const option_supply = {};
          this.resData.supply_list.forEach((v, index) => {
            this.resData.supply_list[index].wait_cg_num = Number(v.wait_cg_num);
            this.resData.supply_list[index].wait_cg_total = Number(
              v.wait_cg_total
            );
            this.resData.supply_list[index].wpc_num = Number(v.wpc_num);
            if (!option_supply[v.supply_id]) {
              option_supply[v.supply_id] = {
                supply_id: v.supply_id,
                supply_name: v.supply_name,
              };
            }
          });
          this.option.supply_list = Object.values(option_supply);
        }
      });
    },

    getUrl() {
      this.form.ptype = this.plan_source;
      return {
        1: this.url,
        9: "/erp/SampleGoodsPlan/sgpWaitCgListGet",
        10: "/erp/SampleGoodsPlan/sgpWaitCgListGet",
        11: "/erp/SampleGoodsPlan/sgpWaitCgListGet",
        199: "/erp/WcgPlan/waitConfirmSupplyList",
      }[this.plan_source];
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchaseverify/WaitingPurchase.vue